export default "__VITE_ASSET__B0E2QL20__"